import { useMemo } from 'react';
import { useFunnelStatuses } from '../../../../../shared/hooks/api/crm/funnels/funnel-statuses';
import { createQuery } from 'src/modules/shared/utils/api/query-builder.util';
import { PipelineBoard } from './board';
import { PipelineBoardSkeleton } from './board/pipeline-board-skeleton';
import {
  type SearcherDocumentSearchFilter,
  type SearcherDocumentSearchSort,
} from 'src/api/generated';

interface ConversationPipelineViewProps {
  selectedFunnelId?: number;
  searchTerm?: string;
  onConversationSelect?: (id: number) => void;
  onOpenContactProfile?: (id: number) => void;
  selectedConversationId?: number;
  filters: SearcherDocumentSearchFilter[];
  sorts: SearcherDocumentSearchSort[];
  aiStatusIds?: number[];
}

export const ConversationPipelineView: React.FC<
  ConversationPipelineViewProps
> = ({
  selectedFunnelId,
  searchTerm,
  onConversationSelect,
  onOpenContactProfile,
  selectedConversationId,
  filters,
  sorts,
  aiStatusIds = [],
}) => {
  const statusQuery = useMemo(() => {
    if (!selectedFunnelId) return {};

    return createQuery()
      .equals('funnelId', selectedFunnelId)
      .orderByAsc('position')
      .build();
  }, [selectedFunnelId]);

  const { statuses, loading: loadingStatuses } = useFunnelStatuses(
    statusQuery,
    !!selectedFunnelId
  );

  if (loadingStatuses) return <PipelineBoardSkeleton />;

  return (
    <PipelineBoard
      statuses={statuses}
      selectedFunnelId={selectedFunnelId}
      searchTerm={searchTerm}
      onConversationSelect={(id) => onConversationSelect?.(Number(id))}
      onOpenContactProfile={onOpenContactProfile}
      selectedConversationId={selectedConversationId?.toString()}
      filters={filters}
      sorts={sorts}
      aiStatusIds={aiStatusIds}
    />
  );
};
